import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const InvitesChecklist = ({ usersToAdd, setUsersToAdd }) => {
    if (
        usersToAdd &&
        usersToAdd.filter((user) => user.isRegistered === false || !user.isRegistered).length === 0
    ) {
        return <p>All users are already in platform</p>;
    }
    const handleChange = (event, user) => {
        const updatedUsers = usersToAdd.map((u) => {
            if (u.email === user.email) {
                return { ...u, invite: event.target.checked ?? false };
            }
            return u;
        });
        setUsersToAdd(updatedUsers);
    };

    return (
        <Box sx={{ display: "flex" }}>
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                <FormGroup size="small">
                    {usersToAdd
                        .filter((user) => user.isRegistered === false)
                        .map((user) => (
                            <FormControlLabel
                                key={user.email}
                                control={
                                    <Checkbox
                                        checked={!!user.invite}
                                        onChange={(e) => handleChange(e, user)}
                                        name={user.displayName || user.email}
                                        size="small"
                                    />
                                }
                                label={user.displayName || user.email}
                            />
                        ))}
                </FormGroup>
            </FormControl>
        </Box>
    );
};

export default InvitesChecklist;
